export enum TipoComposicaoCodigoBarrasEnum {
  PorPreco = 1,
  PorPeso = 2,
}
